import { createClient } from '@supabase/supabase-js';

// Initialize the Supabase client with environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Please check your .env file.');
  console.error('REACT_APP_SUPABASE_URL:', supabaseUrl);
  console.error('REACT_APP_SUPABASE_ANON_KEY exists:', !!supabaseAnonKey);
}

// Create a single supabase client for the entire app
export const supabase = createClient(
  supabaseUrl || 'https://rwwytzhrtnqvvefknmzi.supabase.co', 
  supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ3d3l0emhydG5xdnZlZmtubXppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc4NDk4MTQsImV4cCI6MjA2MzQyNTgxNH0.dohUVcVKywN_Qvirl29BnjSVekJIA76-7ixqECFKakQ'
);

// Export helper functions for common Supabase operations
export const getUser = () => supabase.auth.getUser();
export const getSession = () => supabase.auth.getSession();
